import { useNavigation } from "inbounds/navigation/useNavigation";
import { storageInboundStepToPath } from "inbounds/steps/StorageInboundStepRoutes";
import { StorageInboundStep } from "../StorageInboundStep";
import { storageInboundEnabledStepMap } from "./storageInboundEnabledStepMap";

export const useStorageInboundNavigation = () => {
  return useNavigation<StorageInboundStep>(StorageInboundStep, storageInboundStepToPath, storageInboundEnabledStepMap);
};
